import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import AdminSidebar, { activeAdminItem } from '../pages/AdminSidebar';
import './AdminLayout.css';
export default function AdminLayout() {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const item = activeAdminItem(pathname);
  useEffect(() => setMenuOpen(false), [pathname]);
  return <div className="admin-layout">
    <button className="admin-mobile-toggle" aria-expanded={menuOpen} aria-controls="admin-sidebar" onClick={() => setMenuOpen(value => !value)}>{menuOpen ? 'Fechar menu' : 'Abrir menu'} · SuperAdmin</button>
    <aside id="admin-sidebar" className={'admin-sidebar' + (menuOpen ? ' is-open' : '')}><AdminSidebar /></aside>
    <main className="admin-content"><div className="admin-content-inner">
      {item && <div className="admin-path" aria-label="Localização atual">{item.group}{item.label !== item.group && ' / ' + item.label}{item.path === 'campanhas' && (pathname.endsWith('/historico') ? ' / Histórico de desempenho' : ' / Monitoramento')}</div>}
      <Outlet />
    </div></main>
  </div>;
}
